import type { ReactNode } from 'react'
import {
  ModalDialog,
  ModalDialogActions,
  ModalDialogContent,
  ModalDialogDescription,
  ModalDialogFooter,
  ModalDialogHeader,
  ModalDialogTitle,
} from '@/components/ModalDialog'
import { Button } from '@/components/Button'

export interface RenameDocumentDialogProps {
  children?: ReactNode
  isOpen: boolean
  onClose?: () => unknown
  isDismissable?: boolean
  isRenamePending?: boolean
  submitButtonForm?: string
  testId?: string
  renameButtonTestId?: string
  cancelButtonTestId?: string
}

/**
 * A dialog for renaming a document.
 */
export function RenameDocumentDialog({
  children,
  isOpen,
  onClose,
  isDismissable,
  isRenamePending,
  submitButtonForm,
  testId,
  renameButtonTestId,
  cancelButtonTestId,
}: RenameDocumentDialogProps) {
  return (
    <ModalDialog
      isOpen={isOpen}
      onClose={onClose}
      isDismissable={isDismissable}
      testId={testId}
    >
      <ModalDialogHeader>
        <ModalDialogTitle>Rename document</ModalDialogTitle>
        <ModalDialogDescription>
          This change will be reflected for anyone who has access to this file.
        </ModalDialogDescription>
      </ModalDialogHeader>
      <ModalDialogContent spacing="compact">
        <div className="py-sm">{children}</div>
      </ModalDialogContent>
      <ModalDialogFooter>
        <ModalDialogActions>
          <Button
            isPending={isRenamePending}
            label="Rename"
            type="submit"
            form={submitButtonForm}
            testId={renameButtonTestId}
          />
          <Button
            isDisabled={isRenamePending}
            variant="outline"
            label="Cancel"
            onPress={onClose}
            testId={cancelButtonTestId}
          />
        </ModalDialogActions>
      </ModalDialogFooter>
    </ModalDialog>
  )
}
